import axios from 'axios';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DateFilterButtonData from '../../common/DateFilterButtonData';
import { ko } from 'date-fns/esm/locale';
import CheckBox from '../../common/CheckBox';
import {
	changeMarketData,
	parseMarketOrderStatus,
	parseVendorOrderStatus,
} from '../../common/utils';
import resetIcon from '../../../img/resetIcon.png';

function OrderSearch(props) {
	const qs = require('qs');

	const [MarketList, setMarketList] = useState([]); // 초기값 설정
	const [CheckedMarket, setCheckedMarket] = useState([]);
	const [IsVendor, setIsVendor] = useState(false);
	const [VendorList, setVendorList] = useState([]); // 초기값 설정
	const [CheckedVendor, setCheckedVendor] = useState([]);
	const [MordersList, setMordersList] = useState([]);
	const [CheckedMorders, setCheckedMorders] = useState([
		'PAYED',
		'CANCEL_REQUEST',
		'EXCHANGE_REQUEST',
		'RETURN_REQUEST',
	]);
	const [VordersList, setVordersList] = useState([]);
	const [CheckedVorders, setCheckedVorders] = useState([
		'ORDER_WAITING',
		'ORDERED',
		'RELEASED',
		'ERROR',
	]);

	const [IsSetDate, setIsSetDate] = useState(false);
	const [StartDate, setStartDate] = useState('');
	const [EndDate, setEndDate] = useState('');
	const [BtnClicked, setBtnClicked] = useState('');
	const [Month, setMonth] = useState(new Date().getMonth());

	const [IsOrderId, setIsOrderId] = useState(false);
	const [OrderId, setOrderId] = useState('');
	const [OrderIdType, setOrderIdType] = useState('orderId');

	const [IsOrdererReceiver, setIsOrdererReceiver] = useState(false);
	const [OrdererReceiver, setOrdererReceiver] = useState('');
	const [OrdererReceiverType, setOrdererReceiverType] = useState('ordererName');

	const [IsCode, setIsCode] = useState(false);
	const [Code, setCode] = useState('');
	const Params = {
		marketCode: CheckedMarket,
		vendorCode: CheckedVendor,
		marketOrderStatus: CheckedMorders,
		vendorOrderStatus: CheckedVorders,
		paymentDate: {
			before: StartDate,
			after: EndDate,
		},
		[OrderIdType]: OrderId,
		[OrdererReceiverType]: OrdererReceiver,
		manageCode: Code,
	};

	const orderIdRadioList = [
		{
			value: 'orderId',
			label: '주문번호',
		},
		{
			value: 'productOrderId',
			label: '상품주문번호',
		},
		{
			value: 'vendorOrderId',
			label: '도매사주문번호',
		},
	];
	const OrdererReceiverRadioList = [
		{
			value: 'ordererName',
			label: '주문자',
		},
		{
			value: 'receiverName',
			label: '수취인',
		},
	];
	// 날짜 버튼 클릭, 기간 변경 기능
	const handleBtnClicked = (e) => {
		const newValue = e.target.value;
		setBtnClicked(newValue);
		// if (value === "전체") {
		//   setStartDate();
		//   setEndDate();
		// }

		// 오늘 날짜
		let today = new Date();
		let newDay = new Date();
		if (newValue === '오늘') {
			setStartDate(today.valueOf());
			setEndDate(today.valueOf());
		}
		// 1주일 전부터 오늘까지의 기간
		if (newValue === '1주일') {
			setStartDate(newDay.setDate(today.getDate() - 7).valueOf());
			setEndDate(today.valueOf());
		}
		// 1개월 전부터 오늘까지의 기간
		if (newValue === '1개월') {
			setStartDate(newDay.setMonth(today.getMonth() - 1).valueOf());
			setEndDate(today.valueOf());
		}
		// 3개월 전부터 오늘까지의 기간
		if (newValue === '3개월') {
			setStartDate(newDay.setMonth(today.getMonth() - 3).valueOf());
			setEndDate(today.valueOf());
		}
		//6개월 전부터 오늘까지의 기간
		if (newValue === '6개월') {
			setStartDate(newDay.setMonth(today.getMonth() - 6).valueOf());
			setEndDate(today.valueOf());
		}
		// 1년 전부터 오늘까지의 기간
		if (newValue === '1년') {
			setStartDate(newDay.setFullYear(today.getFullYear() - 1).valueOf());
			setEndDate(today.valueOf());
		}
		// 전체
		if (newValue === '전체') {
			setStartDate(null);
			setEndDate(null);
		}
		//unix타임을 반환하는 메서트 date.valueOf()
	};

	const handleMonthChange = (date) => {
		setMonth(date.getMonth());
	};
	const changeClassName = (inputId, newClassName) => {
		//주문일자 버튼 활성화 class 제거 로직
		const inputElement = document.getElementById(inputId);
		if (inputElement) {
			inputElement.className = newClassName;
		} else {
			console.log(`Input element with ID '${inputId}' not found.`);
		}
	};

	const handleInputChange = (value, type) => {
		const newValue = value;

		if (type === 'OrderId') {
			return setOrderId(newValue);
		} else if (type === 'OrdererReceiver') {
			return setOrdererReceiver(newValue);
		} else {
			//Code
			return setCode(newValue);
		}
	};

	const handleOrderIdTypeChange = (event) => {
		const newValue = event.target.value;
		setOrderIdType(newValue);
	};
	const handleOrdererReceiverTypeChange = (event) => {
		const newValue = event.target.value;
		setOrdererReceiverType(newValue);
	};

	useEffect(() => {
		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getMarket`,
				qs.stringify({
					token: localStorage.getItem('token'),
				})
			)
			.then((res) => {
				// setLogo(true);
				// setItems(res.data.productInfo || []);
				// setCount(res.data.productInfo.length);
				setMarketList(res.data);
			})
			.catch();

		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getVendor`,
				qs.stringify({
					token: localStorage.getItem('token'),
				})
			)
			.then((res) => {
				// setLogo(true);
				// setItems(res.data.productInfo || []);
				// setCount(res.data.productInfo.length);
				const valuesArray = res.data.map((obj) => obj.vendorCode);
				setVendorList(valuesArray);
			})
			.catch();
		setMordersList([
			'PAYED',
			'ORDER_WAITING',
			'DELIVERY_WAITING',
			'DELIVERING',
			'DELIVERED',
			'PURCHASE_DECIDED',
			'CANCEL_REQUEST',
			'CANCELED',
			'EXCHANGE_REQUEST',
			'EXCHANGE_REDELIVERING',
			'EXCHANGED',
			'RETURN_REQUEST',
			'COLLECTING',
			'RETURNED',
		]);
		setVordersList(['ORDER_WAITING', 'ORDERED', 'RELEASED', 'ERROR']);

		//첫페이지 로드 시 디폴트값으로 검색
		props.getParams(Params);
	}, []);

	const reset = (e) => {
		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getMarket`,
				qs.stringify({
					token: localStorage.getItem('token'),
				})
			)
			.then((res) => {
				// setLogo(true);
				// setItems(res.data.productInfo || []);
				// setCount(res.data.productInfo.length);
				setCheckedMarket(res.data);
			})
			.catch();
		setIsVendor(false);
		setCheckedVendor([]);
		setCheckedMorders([
			'PAYED',
			'CANCEL_REQUEST',
			'EXCHANGE_REQUEST',
			'RETURN_REQUEST',
		]);
		setCheckedVorders(['ORDER_WAITING', 'ORDERED', 'RELEASED', 'ERROR']);
		setIsSetDate(false);
		setBtnClicked('');
		setStartDate('');
		setEndDate('');
		setIsOrderId(false);
		setOrderId('');
		setOrderIdType('orderId');
		setIsOrdererReceiver(false);
		setOrdererReceiver('');
		setOrdererReceiverType('ordererName');
		setIsCode(false);
		setCode('');
	};

	const onSearch = (e) => {
		e.preventDefault();
		// value가 ""인 key는 안보내면 자동으로 ""로 전체 검색이 됨.
		if (CheckedMarket.length <= 0) {
			return alert('하나 이상의 마켓을 선택해주십시오.');
		}
		if (IsVendor && CheckedVendor.length <= 0) {
			return alert('하나 이상의 도매사를 선택해주십시오.');
		}
		if (CheckedMorders.length <= 0 || CheckedVorders.length <= 0) {
			return alert('하나 이상의 주문상태를 선택해주십시오.');
		}
		if (IsSetDate && (StartDate === '' || EndDate === '')) {
			return alert('시작일과 종료일을 선택해주십시오.');
		}
		if (IsOrderId && OrderId === '') {
			return alert('올바른 주문번호를 입력해주십시오.');
		}
		if (IsOrdererReceiver && OrdererReceiver === '') {
			return alert('올바른 주문자/수취인을 입력해주십시오.');
		}
		if (IsCode && (Code === '' || Code === '')) {
			return alert('올바른 상품관리코드를 입력해주십시오.');
		}
		const newParams = {
			marketCode: CheckedMarket,
			vendorCode: CheckedVendor,
			marketOrderStatus: CheckedMorders,
			vendorOrderStatus: CheckedVorders,
			paymentDate: {
				before: StartDate,
				after: EndDate,
			},
			[OrderIdType]: OrderId,
			[OrdererReceiverType]: OrdererReceiver,
			manageCode: Code,
		};

		props.getParams(newParams);
	};

	useEffect(() => {
		const newCountParmas = props.countParams;
		reset();
		if (newCountParmas.marketOrderStatus?.length > 0) {
			setCheckedMorders(newCountParmas.marketOrderStatus);
		}
		return;
	}, [props.countParams]);

	return (
		<>
			<form onSubmit={(e) => onSearch(e)} className='searchForm'>
				<table>
					<tbody>
						<tr>
							<th>마켓</th>
							<td>
								<CheckBox
									itemList={MarketList}
									getCheckedList={(e) => setCheckedMarket(e)}
									updateList={CheckedMarket}
									defaultCheckedList={MarketList}
									isAllCheck={true}
									parseStatus={changeMarketData}
								/>
							</td>
						</tr>
						<tr>
							<th>도매사</th>
							<td>
								<div className='checkboxItem'>
									<label>
										<input
											type='checkbox'
											id='IsVendor'
											name='IsVendor'
											checked={IsVendor}
											onChange={() => {
												setIsVendor(!IsVendor);
												setCheckedVendor([]);
											}}
											value={IsVendor || ''}
										/>
										<span>설정함</span>
									</label>
								</div>
								{IsVendor && (
									<>
										<CheckBox
											itemList={VendorList}
											updateList={CheckedVendor}
											getCheckedList={(e) => setCheckedVendor(e)}
											isAllCheck={true}
										/>
									</>
								)}
							</td>
						</tr>
						<tr>
							<th>마켓주문상태</th>
							<td>
								<CheckBox
									itemList={MordersList}
									getCheckedList={(e) => setCheckedMorders(e)}
									updateList={CheckedMorders}
									defaultCheckedList={[
										'PAYED',
										'CANCEL_REQUEST',
										'EXCHANGE_REQUEST',
										'RETURN_REQUEST',
									]}
									isAllCheck={true}
									parseStatus={parseMarketOrderStatus}
								/>
							</td>
						</tr>
						<tr>
							<th>도매사주문상태</th>
							<td>
								<CheckBox
									itemList={VordersList}
									getCheckedList={(e) => setCheckedVorders(e)}
									updateList={CheckedVorders}
									defaultCheckedList={[
										'ORDER_WAITING',
										'ORDERED',
										'RELEASED',
										'ERROR',
									]}
									isAllCheck={true}
									parseStatus={parseVendorOrderStatus}
								/>
							</td>
						</tr>
						<tr>
							<th>주문일자</th>
							<td>
								<div className='checkboxItem'>
									<label>
										<input
											type='checkbox'
											id='IsSetDate'
											name='IsSetDate'
											checked={IsSetDate}
											onChange={() => {
												setIsSetDate(!IsSetDate);
												setBtnClicked('');
												setStartDate('');
												setEndDate('');
											}}
											value={IsSetDate || ''}
										/>
										<span>설정함</span>
									</label>
								</div>
								{IsSetDate && (
									<>
										<div className='datePickerBox'>
											<div>
												{DateFilterButtonData.map((el, index) => (
													<input
														type='button'
														id={el}
														onClick={(e) => handleBtnClicked(e)}
														key={index}
														className={BtnClicked === el ? 'isActive' : ''}
														value={el || ''}
													/>
												))}
											</div>
											<div className='datePicker'>
												<DatePicker
													locale={ko} // 언어설정 기본값은 영어
													dateFormat='yyyy-MM-dd' // 날짜 형식 설정
													className='input-datepicker' // 클래스 명 지정 css주기 위해
													closeOnScroll={true} // 스크롤을 움직였을 때 자동으로 닫히도록 설정 기본값 false
													placeholderText='시작일 선택'
													selected={StartDate} // value
													onChange={(date) => {
														changeClassName(BtnClicked, '');
														setStartDate(date.valueOf());
													}} // 날짜를 선택하였을 때 실행될 함수
													onMonthChange={handleMonthChange}
												/>
												<span>~</span>
												<DatePicker
													locale={ko}
													dateFormat='yyyy-MM-dd'
													className='input-datepicker'
													minDate={StartDate} // 선택할 수 있는 최소 날짜값 지정
													closeOnScroll={true}
													placeholderText='종료일 선택'
													selected={EndDate}
													onChange={(date) => {
														changeClassName(BtnClicked, '');
														setEndDate(date.valueOf());
													}}
													onMonthChange={handleMonthChange}
												/>
											</div>
										</div>
									</>
								)}
							</td>
						</tr>
						<tr>
							<th>주문번호</th>
							<td>
								<div className='checkboxItem'>
									<label>
										<input
											type='checkbox'
											id='IsOrderId'
											name='IsOrderId'
											checked={IsOrderId}
											onChange={() => {
												setIsOrderId(!IsOrderId);
												setOrderId('');
												setOrderIdType('orderId');
											}}
											value={IsOrderId || ''}
										/>
										<span>설정함</span>
									</label>
								</div>
								{IsOrderId && (
									<>
										<div className='radioItem'>
											{orderIdRadioList.map((el, index) => (
												<label key={index}>
													<input
														type='radio'
														name='OrderIdType'
														value={el.value || ''}
														onChange={handleOrderIdTypeChange}
														defaultChecked={index === 0} //초기화시 어떻게 될지.
													/>
													<span>{el.label}</span>
												</label>
											))}
										</div>
										<input
											type='text'
											id='OrderId'
											name='OrderId'
											onChange={(e) =>
												handleInputChange(e.target.value, 'OrderId')
											}
											value={OrderId || ''}
										></input>
									</>
								)}
							</td>
						</tr>
						<tr>
							<th>주문자/수취인</th>
							<td>
								<div className='checkboxItem'>
									<label>
										<input
											type='checkbox'
											id='IsOrdererReceiver'
											name='IsOrdererReceiver'
											checked={IsOrdererReceiver}
											onChange={() => {
												setIsOrdererReceiver(!IsOrdererReceiver);
												setOrdererReceiver('');
												setOrdererReceiverType('ordererName');
											}}
											value={IsOrdererReceiver || ''}
										/>
										<span>설정함</span>
									</label>
								</div>
								{IsOrdererReceiver && (
									<>
										<div className='radioItem'>
											{OrdererReceiverRadioList.map((el, index) => (
												<label key={index}>
													<input
														type='radio'
														name='OrdererReceiverType'
														value={el.value || ''}
														onChange={handleOrdererReceiverTypeChange}
														defaultChecked={index === 0} //초기화시 어떻게 될지.
													/>
													<span>{el.label}</span>
												</label>
											))}
										</div>
										<input
											type='text'
											id='OrdererReceiver'
											name='OrdererReceiver'
											onChange={(e) =>
												handleInputChange(e.target.value, 'OrdererReceiver')
											}
											value={OrdererReceiver || ''}
										></input>
									</>
								)}
							</td>
						</tr>
						<tr>
							<th>상품관리코드</th>
							<td>
								<div className='checkboxItem'>
									<label>
										<input
											type='checkbox'
											id='IsCode'
											name='IsCode'
											checked={IsCode}
											onChange={() => {
												setIsCode(!IsCode);
												setCode('');
											}}
											value={IsCode || ''}
										/>
										<span>설정함</span>
									</label>
								</div>
								{IsCode && (
									<>
										<input
											type='text'
											id='Code'
											name='Code'
											onChange={(e) =>
												handleInputChange(e.target.value, 'Code')
											}
											value={Code || ''}
										></input>
									</>
								)}
							</td>
						</tr>
					</tbody>
				</table>
				<div className='searchBottonBox'>
					<button type='reset' onClick={reset}>
						<span>
							<img src={resetIcon} alt='resetIcon' />
						</span>
						{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
						<span>초기화</span>
					</button>
					<button type='submit'>검색</button>
				</div>
			</form>
		</>
	);
}

export default OrderSearch;
